import actionConstants from '../constants/';

const getRefundList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getEdgeRefFileRefundList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const createRefund = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  errorDetails: '',
};

const createV3Refund = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const createRefundViaPayoutState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const refundBulkUploadHistoryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const edgeRefundBulkUploadHistoryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const getAllRefundStatusList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const getEMIAndProductDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getRefundDetail = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const initialState = {
  refundList: { ...getRefundList },
  createRefund: { ...createRefund },
  refundBulkUploadHistoryState: { ...refundBulkUploadHistoryState },
  getAllRefundStatusList: { ...getAllRefundStatusList },
  getEMIAndProductDetails: { ...getEMIAndProductDetails },
  edgeRefundBulkUploadHistoryState: { ...edgeRefundBulkUploadHistoryState },
  getEdgeRefFileRefundList: { ...getEdgeRefFileRefundList },
  getRefundDetail: { ...getRefundDetail },
  createV3Refund: { ...createV3Refund },
  createRefundViaPayoutState: {...createRefundViaPayoutState},
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function refundReducer(state = initialState, action) {
  switch (action.type) {
    
    case actionConstants.POST_CREATE_REFUND_VIA_PAYOUT_REQUEST:
      return{
        ...state,
        createRefundViaPayoutState: {
          ...state.createRefundViaPayoutState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.POST_CREATE_REFUND_VIA_PAYOUT_SUCCESS:
      return {
        ...state,
        createRefundViaPayoutState: {
          ...state.createRefundViaPayoutState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.POST_CREATE_REFUND_VIA_PAYOUT_FAILURE:
      return {
        ...state,
        createRefundViaPayoutState: {
          ...state.createRefundViaPayoutState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.OpCode,
          errorMessage: action?.payload?.body?.message
        },
      };
    case actionConstants.POST_CREATE_REFUND_VIA_PAYOUT_CLEAR:
      return {
        ...state,
        createRefundViaPayoutState: {
          ...initialState.createRefundViaPayoutState,
        },
      };

    case actionConstants.GET_REFUND_LIST_REQUEST:
      return {
        ...state,
        refundList: {
          ...state.refundList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REFUND_LIST_SUCCESS:
      return {
        ...state,
        refundList: {
          ...state.refundList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_LIST_FAILURE:
      return {
        ...state,
        refundList: {
          ...state.refundList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_LIST_CLEAR:
      return {
        ...state,
        refundList: {
          ...initialState.refundList,
          data: {},
        },
      };
    case actionConstants.GET_REF_FILE_REFUND_LIST_REQUEST:
      return {
        ...state,
        getEdgeRefFileRefundList: {
          ...state.getEdgeRefFileRefundList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REF_FILE_REFUND_LIST_SUCCESS:
      return {
        ...state,
        getEdgeRefFileRefundList: {
          ...state.getEdgeRefFileRefundList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REF_FILE_REFUND_LIST_FAILURE:
      return {
        ...state,
        getEdgeRefFileRefundList: {
          ...state.getEdgeRefFileRefundList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REF_FILE_REFUND_LIST_CLEAR:
      return {
        ...state,
        getEdgeRefFileRefundList: {
          ...initialState.getEdgeRefFileRefundList,
          data: [],
        },
      };

    case actionConstants.GET_REFUND_DETAIL_SUCCESS:
      return {
        ...state,
        getRefundDetail: {
          ...state.getRefundDetail,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_DETAIL_FAILURE:
      return {
        ...state,
        getRefundDetail: {
          ...state.getRefundDetail,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_DETAIL_CLEAR:
      return {
        ...state,
        getRefundDetail: {
          ...initialState.getRefundDetail,
          data: [],
        },
      };

    case actionConstants.POST_CREATE_REFUND_REQUEST:
      return {
        ...state,
        createRefund: {
          ...state.createRefund,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST:
      return {
        ...state,
        refundBulkUploadHistoryState: {
          ...state.refundBulkUploadHistoryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        refundBulkUploadHistoryState: {
          ...state.refundBulkUploadHistoryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE:
      return {
        ...state,
        refundBulkUploadHistoryState: {
          ...state.refundBulkUploadHistoryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR:
      return {
        ...state,
        refundBulkUploadHistoryState: {
          ...initialState.refundBulkUploadHistoryState,
          data: [],
        },
      };

    case actionConstants.GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_REQUEST:
      return {
        ...state,
        edgeRefundBulkUploadHistoryState: {
          ...state.edgeRefundBulkUploadHistoryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        edgeRefundBulkUploadHistoryState: {
          ...state.edgeRefundBulkUploadHistoryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_FAILURE:
      return {
        ...state,
        edgeRefundBulkUploadHistoryState: {
          ...state.edgeRefundBulkUploadHistoryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST_CLEAR:
      return {
        ...state,
        edgeRefundBulkUploadHistoryState: {
          ...initialState.edgeRefundBulkUploadHistoryState,
          data: [],
        },
      };

    case actionConstants.POST_CREATE_REFUND_SUCCESS:
      return {
        ...state,
        createRefund: {
          ...state.createRefund,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.POST_CREATE_REFUND_FAILURE:
      return {
        ...state,
        createRefund: {
          ...state.createRefund,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code || action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.error_message || action?.payload?.body?.errorMessage,
          errorDetails: action?.payload?.body?.errorDetails?.[0]?.message
        },
      };

    case actionConstants.POST_CREATE_REFUND_CLEAR:
      return {
        ...state,
        createRefund: {
          ...createRefund,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_REFUND_STATUS_LIST_REQUEST:
      return {
        ...state,
        getAllRefundStatusList: {
          ...state.getAllRefundStatusList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_ALL_REFUND_STATUS_LIST_SUCCESS:
      return {
        ...state,
        getAllRefundStatusList: {
          ...state.getAllRefundStatusList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_REFUND_STATUS_LIST_FAILURE:
      return {
        ...state,
        getAllRefundStatusList: {
          ...state.getAllRefundStatusList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_ALL_REFUND_STATUS_LIST_CLEAR:
      return {
        ...state,
        getAllRefundStatusList: {
          ...initialState.getAllRefundStatusList,
          data: [],
        },
      };

    case actionConstants.GET_EMI_PRODUCT_DETAILS_FOR_REFUND_REQUEST:
      return {
        ...state,
        getEMIAndProductDetails: {
          ...getEMIAndProductDetails,
          isLoading: true,
        },
      };

    case actionConstants.GET_EMI_PRODUCT_DETAILS_FOR_REFUND_SUCCESS:
      return {
        ...state,
        getEMIAndProductDetails: {
          ...state.getEMIAndProductDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EMI_PRODUCT_DETAILS_FOR_REFUND_FAILURE:
      return {
        ...state,
        getEMIAndProductDetails: {
          ...state.getEMIAndProductDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EMI_PRODUCT_DETAILS_FOR_REFUND_CLEAR:
      return {
        ...state,
        getEMIAndProductDetails: {
          ...getEMIAndProductDetails,
        },
      };

    case actionConstants.POST_CREATE_V3_REFUND_REQUEST:
      return {
        ...state,
        createV3Refund: {
          ...state.createV3Refund,
          isLoading: true,
        },
      };

    case actionConstants.POST_CREATE_V3_REFUND_SUCCESS:
      return {
        ...state,
        createV3Refund: {
          ...state.createV3Refund,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.POST_CREATE_V3_REFUND_FAILURE:
      return {
        ...state,
        createV3Refund: {
          ...state.createV3Refund,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage: action.payload.body.message,
        },
      };

    case actionConstants.POST_CREATE_V3_REFUND_CLEAR:
      return {
        ...state,
        createV3Refund,
      };

    default:
      return state;
  }
}
